export default "__VITE_ASSET__VQCXQdZC__"